import { useEffect } from 'react';

interface Props {
  increaseFont: () => void;
  decreaseFont: () => void;
  resetFont: () => void;
}

export const useKeyboardShortcuts = ({
  increaseFont,
  decreaseFont,
  resetFont,
}: Props) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!event.altKey) return;

      switch (event.key) {
        case '+':
          increaseFont();
          break;

        case '-':
          decreaseFont();
          break;

        case '0':
          resetFont();
          break;

        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [increaseFont, decreaseFont, resetFont]);
};